module.exports = __webpack_public_path__ + "images/emoji/bath.546053018bebc2c82eed.png";